import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=a8c6a844&scoped=true"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"
import style0 from "./CustomPage.vue?vue&type=style&index=0&id=a8c6a844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c6a844",
  null
  
)

export default component.exports